import store from "../store";
import { Message, Loading, MessageBox } from "element-ui";
import { IdentityCodeValid } from "@/utils/idcard.js";
import { getIterator } from "core-js";

// 刷新页面
export function refresh() {
  this.$router.replace({
    name: "refresh",
    query: {
      t: Date.now(),
    },
  });
}
// 跳页
export function toPath(url) {
  this.$router.push(url);
}
export function needLogin() {
  this.$alert("您需要登录后才能使用此功能", "登录", {
    confirmButtonText: "去登录",
  })
    .then(() => {
      this.$store.dispatch("handleMenu", {
        admin: new Date().valueOf(),
      });
    })
    .catch((err) => {
      // console.log(err);
    });
}
// 清空缓存
export function delAllStorage() {
  sessionStorage.setItem("userJson", "{}");
  sessionStorage.setItem("menuJson", "[]");
  sessionStorage.setItem("token", "");
  sessionStorage.setItem("dictionaryJson", "");
  sessionStorage.setItem("matterDataJson", "{}");
  sessionStorage.setItem("traintypeJson", "[]");
  sessionStorage.removeItem("downloadItems");
  localStorage.removeItem("uploadedFiles");
}

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports),
    t.exports
}

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e
  }
    : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    }
  )(e)
}


/* 表单 */
// 校验 sessionStorage
export function checkSessionsObj(str, stu = "Object") {
  str = sessionStorage.getItem(str);
  if (!str || str === "undefined" || str === "null") {
    if (stu === "Object") {
      return {};
    } else if (stu === "Array") {
      return [];
    } else if (stu === "none") {
      return null;
    } else {
      return "";
    }
  } else {
    return JSON.parse(str);
  }
}
// 类型检测
export function gettyped(data) {
  var gettype = Object.prototype.toString;
  data = gettype.call(data);
  data = data.split(" ")[1];
  data = data.substr(0, data.length - 1);
  return data;
}
// 手机号校验
export function validatePhone(rule, value = "", callback) {
  // ^((\d{4}(-)??)??\d{7})$
  if (value.trim() === "") {
    callback(new Error("请输入手机号码"));
  } else if (value && !/^1[3456789]\d{9}$/.test(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
}
/* 合法url*/
export function validateURL(textval) {
  const urlregex =
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
  if (!urlregex.test(textval)) {
    Message.error({
      message: "请输入正确的链接",
      type: "warning",
    });
    return false;
  } else {
    return urlregex.test(textval);
  }
}
export function validateIdCard(rule, value = "", callback) {
  const chek = IdentityCodeValid(value);
  if (value == "") {
    callback(new Error(chek.tip));
  } else if (value !== "" && !chek.pass) {
    callback(new Error(chek.tip));
  } else {
    callback();
  }
}
export function validateIdCards(rule, value = "", callback) {
  const chek = IdentityCodeValid(value);
  if (value == "") {
    callback();
  } else if (value !== "" && !chek.pass) {
    callback(new Error(chek.tip));
  } else {
    callback();
  }
}
export function validateTime(rule, value, callback) {
  value = value || [];
  if (JSON.stringify(value[0]) === "{}" || !value[0]) {
    callback(new Error("请选择时间范围"));
  } else {
    callback();
  }
}
// 隐藏部分身份证号
export function hideIdCard(str, frontLen, endLen) {
  var len = str.length - frontLen - endLen;
  var xing = "";
  for (var i = 0; i < len; i++) {
    xing += "*";
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
}

/* 文件 */
// 文件上传接口
export function uploadFetch(file, key) {
  let formData = new FormData();
  formData.append("file", file);
  const that = this;
  this.$Postformat("/sys/upload", formData).then((ret) => {
    that.ruleForm[key] = ret.data || "";
  });
}
// 图片验证
export function beforeAvatarUpload(file, self) {
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (
    ["image/png", "image/gif", "image/jpg", "image/jpeg"].indexOf(file.type) ===
    -1
  ) {
    self.$message.error("请上传正确的图片格式");
    return false;
  }
  if (!isLt2M) {
    self.$message.error("上传图片大小不能超过 2MB!");
  }
  return isLt2M;
}
export function requestMine() {
  return;
}
// 图片放大
export function handleBigImg(imgUrl) {
  this.$store.dispatch("handlePicBigUrl", imgUrl);
}
// 文件超出个数限制时的钩子
export function exceedd(files, fileList) {
  this.$message.error("最多上传" + fileList.length + "个文件");
}

// 时间补0
export function add0(val = 1) {
  val = +val;
  return "" + (val <= 9 ? "0" + val : val);
}

/* 数据处理 */
export function setDictionary(type, key) {
  const dictionaryJson = checkSessionsObj("dictionaryJson");
  const items = dictionaryJson[type];
  if (key !== "list") {
    return items[key];
  } else {
    return items;
  }
}
export function getTime(val) {
  let m = parseInt(val / 60);
  let s = val % 60;
  // console.log(m, s);
  if (m < 9) {
    m = "0" + m;
  }
  if (s < 9) {
    s = "0" + s;
  }
  return m + ":" + s;
}
export function resetKeepAlive(to, from, next) {
  //  去的页是 一级 那么不需要缓存
  if (to.meta.level == 1 && from.meta.level == 1) {
    // from.meta.state = false;
    // to.meta.state = true;
    if (this.$vnode.parent) {
      if (to.name != "login") {
        this.$vnode.parent.componentInstance.cache = {};
        this.$vnode.parent.componentInstance.keys = [];
      }
    }
  } else if (to.meta.level == 2 && from.meta.level == 1) {
    // 去的页是二级   需要缓存 当前页
    from.meta.state = true;
  } else if (to.meta.level == 1 && from.meta.level == 2) {
    // 去的页是1级   需要缓存 1级页
    to.meta.state = true;
  }
  next();
}
/**
 * list ---> tree
 */
export function toTree(list = [], id, parent, node, sort) {
  let root = []; // 根目录
  let child = []; // 子目录
  for (let i = 0; i < list.length; i++) {
    if (list[i]) {
      if (list[i][parent] == 0) {
        root.push(list[i]);
      } else {
        child.push(list[i]);
      }
    }
  }
  if (sort !== "") {
    root.sort((a, b) => {
      if (a[sort] < b[sort]) {
        return -1;
      } else if (a[sort] > b[sort]) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  return getTree(root, child, id, parent, node, sort);
}
function getTree(root = [], child = [], id, parent, node, sort) {
  for (let i = 0; i < root.length; i++) {
    if (child.length == 0) {
      return root;
    }
    let nodes = [];
    for (let j = 0; j < child.length; j++) {
      if (child[j][parent] == root[i][id]) {
        nodes.push(child[j]);
      }
    }
    if (sort !== "") {
      nodes.sort((a, b) => {
        if (a[sort] < b[sort]) {
          return -1;
        } else if (a[sort] > b[sort]) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    root[i][node] = nodes;
    getTree(nodes, child, id, parent, node, sort);
  }
  return root;
}

export function connectWebsocket(type) {
  // 点击退出时 - 关闭
  // if (type) {
  //   clearInterval(dsq)
  //   websocket.close();
  //   websocket.onclose = function () { }; //首先禁用onclose处理程序

  // }
  let dsq = null;
  let uid = JSON.parse(sessionStorage.getItem("userJson")).userId;
  var websocket = null;
  if ("WebSocket" in window) {
    if (uid) {
      let baseUrl = this.$baseUrl;
      let url;
      if (!baseUrl.startsWith("http")) {
        url = "://" + location.host + baseUrl;
      } else {
        url = baseUrl.substring(baseUrl.indexOf(":"));
      }
      websocket = new WebSocket("ws" + url + "/websocket/" + uid);
    } else {
      Message.error({
        message: "未检测到您的userId,您可能暂时收不到信息提示!",
        type: "warning",
      });
    }
  } else {
    Message.error({
      message: "该浏览器不支Websocket,您可能收不到实时的消息!",
      type: "warning",
    });
  }
  websocket.onopen = function (event) {
    // 发送一个初始化消息
    websocket.send(uid);
    // 每25秒发向后台发送一个东西,知道前后台在链接,避免脱机或掉线 - 告诉我在；其实可以删掉~！！
    dsq = setInterval(() => {
      websocket.send(uid);
    }, 5000);
    // 接收消息
    websocket.onmessage = function (event) {
      store.state.websocketData = event.data;
    };
    setTimeout(() => {
      websocket.close();
      clearInterval(dsq);
    }, 10000);
  };
  // 关闭websocket
  websocket.onclose = function (event) {
    clearInterval(dsq);
    connectWebsocket();
  };
  // 通信发生错误
  websocket.onerror = function () {
    websocket.close();
  };
  // 页面离开/或者刷新时触发该事件
  window.onbeforeunload = function () {
    websocket.onclose = function () {}; //首先禁用onclose处理程序
    websocket.close();
  };
}
// 校验上传文件的大小
export function acceptTypeImg(e) {
  const isLt2M = e.file.size / 1024 / 1024 < 10;
  if (!isLt2M) {
    return true;
  } else {
    return false;
  }
}
// 判断服务器的地址属于什么地方（可添加多个区域的ip地址，以防以后添加新的区域服务器）
const serverHostnameOBJ = {
  InnerMongolia: {
    title: "内蒙古自治区工伤预防线上培训平台",
    hostname: ["nmgsyf.bjsrxx.com"],
    flag: 1,
  },
  InnerEnterprise: {
    title: "安知企培",
    hostname: ["azqp.bjsrxx1.com"],
    flag: 2,
  },
  // 人力资源配置
  humanResources: {
    title: "安知人力资源服务平台",
    hostname: ["azqp.bjsrxx.com"],
    flag: 3,
  },
  // 新疆:["0.0.0.0","g.giao.com"] （这是示例 可删除）
};
export function judgeServerHostname() {
  const serverHostname = window.location.hostname;
  let serverFlag = null;
  Object.keys(serverHostnameOBJ).forEach((key) => {
    if (serverHostnameOBJ[key]["hostname"].includes(serverHostname)) {
      document.title = serverHostnameOBJ[key]["title"];
      serverFlag = serverHostnameOBJ[key]["flag"];
    }
  });
  return serverFlag;
}

//获取cookie
export function getCookie(name) {
  let arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) {
    return arr[2];
  } else {
    return null;
  }
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, expiredays) {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    value +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
}

//删除cookie
export function delCookie(name) {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

// 清空缓存
export function delAllStorage2() {
  sessionStorage.clear();
  delCookie("token");
  delCookie("userJson");
}

export function bmd5(e) {
  var t = 0,
    r = e.length;
  if (r % 2 != 0) return null;
  r /= 2;
  for (var o = new Array(), n = 0; n < r; n++) {
    var i = e.substr(t, 2),
      i = parseInt(i, 16);
    o.push(i), (t += 2);
  }
  return o;
}

// base64，可以根据实际使用的前端框架进行替换
let base64js_min = createCommonjsModule(function (e, t) {
    e.exports = (function o(n, i, a) {
      function s(t, e) {
        if (!i[t]) {
          if (!n[t]) {
            var r = "function" == typeof commonjsRequire && commonjsRequire;
            if (!e && r) return r(t, !0);
            if (l) return l(t, !0);
            throw (
              (((e = new Error("Cannot find module '" + t + "'")).code =
                "MODULE_NOT_FOUND"),
              e)
            );
          }
          (r = i[t] =
            {
              exports: {},
            }),
            n[t][0].call(
              r.exports,
              function (e) {
                return s(n[t][1][e] || e);
              },
              r,
              r.exports,
              o,
              n,
              i,
              a
            );
        }
        return i[t].exports;
      }
      for (
        var l = "function" == typeof commonjsRequire && commonjsRequire, e = 0;
        e < a.length;
        e++
      )
        s(a[e]);
      return s;
    })(
      {
        "/": [
          function (e, t, r) {
            (r.byteLength = function (e) {
              var e = d(e),
                t = e[0],
                e = e[1];
              return (3 * (t + e)) / 4 - e;
            }),
              (r.toByteArray = function (e) {
                for (
                  var t,
                    r = d(e),
                    o = r[0],
                    r = r[1],
                    n = new u(
                      (function (e, t) {
                        return (3 * (e + t)) / 4 - t;
                      })(o, r)
                    ),
                    i = 0,
                    a = 0 < r ? o - 4 : o,
                    s = 0;
                  s < a;
                  s += 4
                )
                  (t =
                    (l[e.charCodeAt(s)] << 18) |
                    (l[e.charCodeAt(s + 1)] << 12) |
                    (l[e.charCodeAt(s + 2)] << 6) |
                    l[e.charCodeAt(s + 3)]),
                    (n[i++] = (t >> 16) & 255),
                    (n[i++] = (t >> 8) & 255),
                    (n[i++] = 255 & t);
                2 === r &&
                  ((t =
                    (l[e.charCodeAt(s)] << 2) | (l[e.charCodeAt(s + 1)] >> 4)),
                  (n[i++] = 255 & t));
                1 === r &&
                  ((t =
                    (l[e.charCodeAt(s)] << 10) |
                    (l[e.charCodeAt(s + 1)] << 4) |
                    (l[e.charCodeAt(s + 2)] >> 2)),
                  (n[i++] = (t >> 8) & 255),
                  (n[i++] = 255 & t));
                return n;
              }),
              (r.fromByteArray = function (e) {
                for (
                  var t, r = e.length, o = r % 3, n = [], i = 0, a = r - o;
                  i < a;
                  i += 16383
                )
                  n.push(
                    (function (e, t, r) {
                      for (var o, n = [], i = t; i < r; i += 3)
                        (o =
                          ((e[i] << 16) & 16711680) +
                          ((e[i + 1] << 8) & 65280) +
                          (255 & e[i + 2])),
                          n.push(
                            (function (e) {
                              return (
                                s[(e >> 18) & 63] +
                                s[(e >> 12) & 63] +
                                s[(e >> 6) & 63] +
                                s[63 & e]
                              );
                            })(o)
                          );
                      return n.join("");
                    })(e, i, a < i + 16383 ? a : i + 16383)
                  );
                1 == o
                  ? ((t = e[r - 1]),
                    n.push(s[t >> 2] + s[(t << 4) & 63] + "=="))
                  : 2 == o &&
                    ((t = (e[r - 2] << 8) + e[r - 1]),
                    n.push(
                      s[t >> 10] + s[(t >> 4) & 63] + s[(t << 2) & 63] + "="
                    ));
                return n.join("");
              });
            for (
              var s = [],
                l = [],
                u = "undefined" != typeof Uint8Array ? Uint8Array : Array,
                o =
                  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
                n = 0,
                i = o.length;
              n < i;
              ++n
            )
              (s[n] = o[n]), (l[o.charCodeAt(n)] = n);
            function d(e) {
              var t = e.length;
              if (0 < t % 4)
                throw new Error(
                  "Invalid string. Length must be a multiple of 4"
                );
              (e = e.indexOf("=")),
                (t = (e = -1 === e ? t : e) === t ? 0 : 4 - (e % 4));
              return [e, t];
            }
            (l["-".charCodeAt(0)] = 62), (l["_".charCodeAt(0)] = 63);
          },
          {},
        ],
      },
      {},
      []
    )("/");
  }),
  // md5，可以根据实际使用的前端框架进行替换
  md5_min = createCommonjsModule(function (module) {
    !(function () {
      function t(e) {
        e
          ? ((d[0] =
              d[16] =
              d[1] =
              d[2] =
              d[3] =
              d[4] =
              d[5] =
              d[6] =
              d[7] =
              d[8] =
              d[9] =
              d[10] =
              d[11] =
              d[12] =
              d[13] =
              d[14] =
              d[15] =
                0),
            (this.blocks = d),
            (this.buffer8 = l))
          : a
          ? ((e = new ArrayBuffer(68)),
            (this.buffer8 = new Uint8Array(e)),
            (this.blocks = new Uint32Array(e)))
          : (this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
          (this.h0 =
            this.h1 =
            this.h2 =
            this.h3 =
            this.start =
            this.bytes =
            this.hBytes =
              0),
          (this.finalized = this.hashed = !1),
          (this.first = !0);
      }
      var r = "input is invalid type",
        e =
          "object" ==
          ("undefined" == typeof window ? "undefined" : _typeof(window)),
        i = e ? window : {},
        s =
          (i.JS_MD5_NO_WINDOW && (e = !1),
          !e &&
            "object" ==
              ("undefined" == typeof self ? "undefined" : _typeof(self))),
        h =
          !i.JS_MD5_NO_NODE_JS &&
          "object" ==
            ("undefined" == typeof process ? "undefined" : _typeof(process)) &&
          process.versions &&
          process.versions.node,
        f =
          (h ? (i = commonjsGlobal) : s && (i = self),
          !i.JS_MD5_NO_COMMON_JS && module.exports),
        o = !1,
        a = !i.JS_MD5_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
        n = "0123456789abcdef".split(""),
        u = [128, 32768, 8388608, -2147483648],
        y = [0, 8, 16, 24],
        c = ["hex", "array", "digest", "buffer", "arrayBuffer", "base64"],
        p =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(
            ""
          ),
        d = [],
        l,
        A,
        l,
        d,
        b =
          (a &&
            ((A = new ArrayBuffer(68)),
            (l = new Uint8Array(A)),
            (d = new Uint32Array(A))),
          (!i.JS_MD5_NO_NODE_JS && Array.isArray) ||
            (Array.isArray = function (e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            }),
          !a ||
            (!i.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView) ||
            (ArrayBuffer.isView = function (e) {
              return (
                "object" == _typeof(e) &&
                e.buffer &&
                e.buffer.constructor === ArrayBuffer
              );
            }),
          function (r) {
            return function (e) {
              return new t(!0).update(e)[r]();
            };
          }),
        v = function () {
          var r = b("hex");
          ((r = h ? w(r) : r).create = function () {
            return new t();
          }),
            (r.update = function (e) {
              return r.create().update(e);
            });
          for (var e = 0; e < c.length; ++e) {
            var o = c[e];
            r[o] = b(o);
          }
          return r;
        },
        w = function w(t) {
          var e = eval("require('crypto')"),
            i = eval("require('buffer').Buffer"),
            s = function (o) {
              if ("string" == typeof o)
                return e.createHash("md5").update(o, "utf8").digest("hex");
              if (null == o) throw r;
              return (
                o.constructor === ArrayBuffer && (o = new Uint8Array(o)),
                Array.isArray(o) || ArrayBuffer.isView(o) || o.constructor === i
                  ? e.createHash("md5").update(new i(o)).digest("hex")
                  : t(o)
              );
            };
          return s;
        },
        _ =
          ((t.prototype.update = function (e) {
            if (!this.finalized) {
              var t,
                o = _typeof(e);
              if ("string" !== o) {
                if ("object" !== o) throw r;
                if (null === e) throw r;
                if (a && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                else if (!(Array.isArray(e) || (a && ArrayBuffer.isView(e))))
                  throw r;
                t = !0;
              }
              for (
                var n,
                  i,
                  s = 0,
                  l = e.length,
                  u = this.blocks,
                  d = this.buffer8;
                s < l;

              ) {
                if (
                  (this.hashed &&
                    ((this.hashed = !1),
                    (u[0] = u[16]),
                    (u[16] =
                      u[1] =
                      u[2] =
                      u[3] =
                      u[4] =
                      u[5] =
                      u[6] =
                      u[7] =
                      u[8] =
                      u[9] =
                      u[10] =
                      u[11] =
                      u[12] =
                      u[13] =
                      u[14] =
                      u[15] =
                        0)),
                  t)
                )
                  if (a)
                    for (i = this.start; s < l && i < 64; ++s) d[i++] = e[s];
                  else
                    for (i = this.start; s < l && i < 64; ++s)
                      u[i >> 2] |= e[s] << y[3 & i++];
                else if (a)
                  for (i = this.start; s < l && i < 64; ++s)
                    (n = e.charCodeAt(s)) < 128
                      ? (d[i++] = n)
                      : (n < 2048
                          ? (d[i++] = 192 | (n >> 6))
                          : (n < 55296 || 57344 <= n
                              ? (d[i++] = 224 | (n >> 12))
                              : ((n =
                                  65536 +
                                  (((1023 & n) << 10) |
                                    (1023 & e.charCodeAt(++s)))),
                                (d[i++] = 240 | (n >> 18)),
                                (d[i++] = 128 | ((n >> 12) & 63))),
                            (d[i++] = 128 | ((n >> 6) & 63))),
                        (d[i++] = 128 | (63 & n)));
                else
                  for (i = this.start; s < l && i < 64; ++s)
                    (n = e.charCodeAt(s)) < 128
                      ? (u[i >> 2] |= n << y[3 & i++])
                      : (n < 2048
                          ? (u[i >> 2] |= (192 | (n >> 6)) << y[3 & i++])
                          : (n < 55296 || 57344 <= n
                              ? (u[i >> 2] |= (224 | (n >> 12)) << y[3 & i++])
                              : ((n =
                                  65536 +
                                  (((1023 & n) << 10) |
                                    (1023 & e.charCodeAt(++s)))),
                                (u[i >> 2] |= (240 | (n >> 18)) << y[3 & i++]),
                                (u[i >> 2] |=
                                  (128 | ((n >> 12) & 63)) << y[3 & i++])),
                            (u[i >> 2] |=
                              (128 | ((n >> 6) & 63)) << y[3 & i++])),
                        (u[i >> 2] |= (128 | (63 & n)) << y[3 & i++]));
                (this.lastByteIndex = i),
                  (this.bytes += i - this.start),
                  64 <= i
                    ? ((this.start = i - 64), this.hash(), (this.hashed = !0))
                    : (this.start = i);
              }
              return (
                4294967295 < this.bytes &&
                  ((this.hBytes += (this.bytes / 4294967296) << 0),
                  (this.bytes = this.bytes % 4294967296)),
                this
              );
            }
          }),
          (t.prototype.finalize = function () {
            var e, t;
            this.finalized ||
              ((this.finalized = !0),
              ((e = this.blocks)[(t = this.lastByteIndex) >> 2] |= u[3 & t]),
              56 <= t &&
                (this.hashed || this.hash(),
                (e[0] = e[16]),
                (e[16] =
                  e[1] =
                  e[2] =
                  e[3] =
                  e[4] =
                  e[5] =
                  e[6] =
                  e[7] =
                  e[8] =
                  e[9] =
                  e[10] =
                  e[11] =
                  e[12] =
                  e[13] =
                  e[14] =
                  e[15] =
                    0)),
              (e[14] = this.bytes << 3),
              (e[15] = (this.hBytes << 3) | (this.bytes >>> 29)),
              this.hash());
          }),
          (t.prototype.hash = function () {
            var e,
              t,
              r,
              o,
              n,
              i = this.blocks,
              a = this.first
                ? ((((a =
                    ((e =
                      ((((e = i[0] - 680876937) << 7) | (e >>> 25)) -
                        271733879) <<
                      0) ^
                      ((t =
                        ((((t =
                          (-271733879 ^
                            ((r =
                              ((((r =
                                (-1732584194 ^ (2004318071 & e)) +
                                i[1] -
                                117830708) <<
                                12) |
                                (r >>> 20)) +
                                e) <<
                              0) &
                              (-271733879 ^ e))) +
                          i[2] -
                          1126478375) <<
                          17) |
                          (t >>> 15)) +
                          r) <<
                        0) &
                        (r ^ e))) +
                    i[3] -
                    1316259209) <<
                    22) |
                    (a >>> 10)) +
                    t) <<
                  0
                : ((e = this.h0),
                  (a = this.h1),
                  (t = this.h2),
                  ((((a +=
                    ((e =
                      ((((e +=
                        ((r = this.h3) ^ (a & (t ^ r))) + i[0] - 680876936) <<
                        7) |
                        (e >>> 25)) +
                        a) <<
                      0) ^
                      ((t =
                        ((((t +=
                          (a ^
                            ((r =
                              ((((r +=
                                (t ^ (e & (a ^ t))) + i[1] - 389564586) <<
                                12) |
                                (r >>> 20)) +
                                e) <<
                              0) &
                              (e ^ a))) +
                          i[2] +
                          606105819) <<
                          17) |
                          (t >>> 15)) +
                          r) <<
                        0) &
                        (r ^ e))) +
                    i[3] -
                    1044525330) <<
                    22) |
                    (a >>> 10)) +
                    t) <<
                    0);
            (a =
              ((((a +=
                ((e =
                  ((((e += (r ^ (a & (t ^ r))) + i[4] - 176418897) << 7) |
                    (e >>> 25)) +
                    a) <<
                  0) ^
                  ((t =
                    ((((t +=
                      (a ^
                        ((r =
                          ((((r += (t ^ (e & (a ^ t))) + i[5] + 1200080426) <<
                            12) |
                            (r >>> 20)) +
                            e) <<
                          0) &
                          (e ^ a))) +
                      i[6] -
                      1473231341) <<
                      17) |
                      (t >>> 15)) +
                      r) <<
                    0) &
                    (r ^ e))) +
                i[7] -
                45705983) <<
                22) |
                (a >>> 10)) +
                t) <<
              0),
              (a =
                ((((a +=
                  ((e =
                    ((((e += (r ^ (a & (t ^ r))) + i[8] + 1770035416) << 7) |
                      (e >>> 25)) +
                      a) <<
                    0) ^
                    ((t =
                      ((((t +=
                        (a ^
                          ((r =
                            ((((r += (t ^ (e & (a ^ t))) + i[9] - 1958414417) <<
                              12) |
                              (r >>> 20)) +
                              e) <<
                            0) &
                            (e ^ a))) +
                        i[10] -
                        42063) <<
                        17) |
                        (t >>> 15)) +
                        r) <<
                      0) &
                      (r ^ e))) +
                  i[11] -
                  1990404162) <<
                  22) |
                  (a >>> 10)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((e =
                    ((((e += (r ^ (a & (t ^ r))) + i[12] + 1804603682) << 7) |
                      (e >>> 25)) +
                      a) <<
                    0) ^
                    ((t =
                      ((((t +=
                        (a ^
                          ((r =
                            ((((r += (t ^ (e & (a ^ t))) + i[13] - 40341101) <<
                              12) |
                              (r >>> 20)) +
                              e) <<
                            0) &
                            (e ^ a))) +
                        i[14] -
                        1502002290) <<
                        17) |
                        (t >>> 15)) +
                        r) <<
                      0) &
                      (r ^ e))) +
                  i[15] +
                  1236535329) <<
                  22) |
                  (a >>> 10)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((r =
                    ((((r +=
                      (a ^
                        (t &
                          ((e =
                            ((((e += (t ^ (r & (a ^ t))) + i[1] - 165796510) <<
                              5) |
                              (e >>> 27)) +
                              a) <<
                            0) ^
                            a))) +
                      i[6] -
                      1069501632) <<
                      9) |
                      (r >>> 23)) +
                      e) <<
                    0) ^
                    (e &
                      ((t =
                        ((((t += (e ^ (a & (r ^ e))) + i[11] + 643717713) <<
                          14) |
                          (t >>> 18)) +
                          r) <<
                        0) ^
                        r))) +
                  i[0] -
                  373897302) <<
                  20) |
                  (a >>> 12)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((r =
                    ((((r +=
                      (a ^
                        (t &
                          ((e =
                            ((((e += (t ^ (r & (a ^ t))) + i[5] - 701558691) <<
                              5) |
                              (e >>> 27)) +
                              a) <<
                            0) ^
                            a))) +
                      i[10] +
                      38016083) <<
                      9) |
                      (r >>> 23)) +
                      e) <<
                    0) ^
                    (e &
                      ((t =
                        ((((t += (e ^ (a & (r ^ e))) + i[15] - 660478335) <<
                          14) |
                          (t >>> 18)) +
                          r) <<
                        0) ^
                        r))) +
                  i[4] -
                  405537848) <<
                  20) |
                  (a >>> 12)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((r =
                    ((((r +=
                      (a ^
                        (t &
                          ((e =
                            ((((e += (t ^ (r & (a ^ t))) + i[9] + 568446438) <<
                              5) |
                              (e >>> 27)) +
                              a) <<
                            0) ^
                            a))) +
                      i[14] -
                      1019803690) <<
                      9) |
                      (r >>> 23)) +
                      e) <<
                    0) ^
                    (e &
                      ((t =
                        ((((t += (e ^ (a & (r ^ e))) + i[3] - 187363961) <<
                          14) |
                          (t >>> 18)) +
                          r) <<
                        0) ^
                        r))) +
                  i[8] +
                  1163531501) <<
                  20) |
                  (a >>> 12)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((r =
                    ((((r +=
                      (a ^
                        (t &
                          ((e =
                            ((((e +=
                              (t ^ (r & (a ^ t))) + i[13] - 1444681467) <<
                              5) |
                              (e >>> 27)) +
                              a) <<
                            0) ^
                            a))) +
                      i[2] -
                      51403784) <<
                      9) |
                      (r >>> 23)) +
                      e) <<
                    0) ^
                    (e &
                      ((t =
                        ((((t += (e ^ (a & (r ^ e))) + i[7] + 1735328473) <<
                          14) |
                          (t >>> 18)) +
                          r) <<
                        0) ^
                        r))) +
                  i[12] -
                  1926607734) <<
                  20) |
                  (a >>> 12)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((n =
                    (r =
                      ((((r +=
                        ((o = a ^ t) ^
                          (e =
                            ((((e += (o ^ r) + i[5] - 378558) << 4) |
                              (e >>> 28)) +
                              a) <<
                            0)) +
                        i[8] -
                        2022574463) <<
                        11) |
                        (r >>> 21)) +
                        e) <<
                      0) ^ e) ^
                    (t =
                      ((((t += (n ^ a) + i[11] + 1839030562) << 16) |
                        (t >>> 16)) +
                        r) <<
                      0)) +
                  i[14] -
                  35309556) <<
                  23) |
                  (a >>> 9)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((n =
                    (r =
                      ((((r +=
                        ((o = a ^ t) ^
                          (e =
                            ((((e += (o ^ r) + i[1] - 1530992060) << 4) |
                              (e >>> 28)) +
                              a) <<
                            0)) +
                        i[4] +
                        1272893353) <<
                        11) |
                        (r >>> 21)) +
                        e) <<
                      0) ^ e) ^
                    (t =
                      ((((t += (n ^ a) + i[7] - 155497632) << 16) |
                        (t >>> 16)) +
                        r) <<
                      0)) +
                  i[10] -
                  1094730640) <<
                  23) |
                  (a >>> 9)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((n =
                    (r =
                      ((((r +=
                        ((o = a ^ t) ^
                          (e =
                            ((((e += (o ^ r) + i[13] + 681279174) << 4) |
                              (e >>> 28)) +
                              a) <<
                            0)) +
                        i[0] -
                        358537222) <<
                        11) |
                        (r >>> 21)) +
                        e) <<
                      0) ^ e) ^
                    (t =
                      ((((t += (n ^ a) + i[3] - 722521979) << 16) |
                        (t >>> 16)) +
                        r) <<
                      0)) +
                  i[6] +
                  76029189) <<
                  23) |
                  (a >>> 9)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((n =
                    (r =
                      ((((r +=
                        ((o = a ^ t) ^
                          (e =
                            ((((e += (o ^ r) + i[9] - 640364487) << 4) |
                              (e >>> 28)) +
                              a) <<
                            0)) +
                        i[12] -
                        421815835) <<
                        11) |
                        (r >>> 21)) +
                        e) <<
                      0) ^ e) ^
                    (t =
                      ((((t += (n ^ a) + i[15] + 530742520) << 16) |
                        (t >>> 16)) +
                        r) <<
                      0)) +
                  i[2] -
                  995338651) <<
                  23) |
                  (a >>> 9)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((r =
                    ((((r +=
                      (a ^
                        ((e =
                          ((((e += (t ^ (a | ~r)) + i[0] - 198630844) << 6) |
                            (e >>> 26)) +
                            a) <<
                          0) |
                          ~t)) +
                      i[7] +
                      1126891415) <<
                      10) |
                      (r >>> 22)) +
                      e) <<
                    0) ^
                    ((t =
                      ((((t += (e ^ (r | ~a)) + i[14] - 1416354905) << 15) |
                        (t >>> 17)) +
                        r) <<
                      0) |
                      ~e)) +
                  i[5] -
                  57434055) <<
                  21) |
                  (a >>> 11)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((r =
                    ((((r +=
                      (a ^
                        ((e =
                          ((((e += (t ^ (a | ~r)) + i[12] + 1700485571) << 6) |
                            (e >>> 26)) +
                            a) <<
                          0) |
                          ~t)) +
                      i[3] -
                      1894986606) <<
                      10) |
                      (r >>> 22)) +
                      e) <<
                    0) ^
                    ((t =
                      ((((t += (e ^ (r | ~a)) + i[10] - 1051523) << 15) |
                        (t >>> 17)) +
                        r) <<
                      0) |
                      ~e)) +
                  i[1] -
                  2054922799) <<
                  21) |
                  (a >>> 11)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((r =
                    ((((r +=
                      (a ^
                        ((e =
                          ((((e += (t ^ (a | ~r)) + i[8] + 1873313359) << 6) |
                            (e >>> 26)) +
                            a) <<
                          0) |
                          ~t)) +
                      i[15] -
                      30611744) <<
                      10) |
                      (r >>> 22)) +
                      e) <<
                    0) ^
                    ((t =
                      ((((t += (e ^ (r | ~a)) + i[6] - 1560198380) << 15) |
                        (t >>> 17)) +
                        r) <<
                      0) |
                      ~e)) +
                  i[13] +
                  1309151649) <<
                  21) |
                  (a >>> 11)) +
                  t) <<
                0),
              (a =
                ((((a +=
                  ((r =
                    ((((r +=
                      (a ^
                        ((e =
                          ((((e += (t ^ (a | ~r)) + i[4] - 145523070) << 6) |
                            (e >>> 26)) +
                            a) <<
                          0) |
                          ~t)) +
                      i[11] -
                      1120210379) <<
                      10) |
                      (r >>> 22)) +
                      e) <<
                    0) ^
                    ((t =
                      ((((t += (e ^ (r | ~a)) + i[2] + 718787259) << 15) |
                        (t >>> 17)) +
                        r) <<
                      0) |
                      ~e)) +
                  i[9] -
                  343485551) <<
                  21) |
                  (a >>> 11)) +
                  t) <<
                0),
              this.first
                ? ((this.h0 = (e + 1732584193) << 0),
                  (this.h1 = (a - 271733879) << 0),
                  (this.h2 = (t - 1732584194) << 0),
                  (this.h3 = (r + 271733878) << 0),
                  (this.first = !1))
                : ((this.h0 = (this.h0 + e) << 0),
                  (this.h1 = (this.h1 + a) << 0),
                  (this.h2 = (this.h2 + t) << 0),
                  (this.h3 = (this.h3 + r) << 0));
          }),
          (t.prototype.hex = function () {
            this.finalize();
            var e = this.h0,
              t = this.h1,
              r = this.h2,
              o = this.h3;
            return (
              n[(e >> 4) & 15] +
              n[15 & e] +
              n[(e >> 12) & 15] +
              n[(e >> 8) & 15] +
              n[(e >> 20) & 15] +
              n[(e >> 16) & 15] +
              n[(e >> 28) & 15] +
              n[(e >> 24) & 15] +
              n[(t >> 4) & 15] +
              n[15 & t] +
              n[(t >> 12) & 15] +
              n[(t >> 8) & 15] +
              n[(t >> 20) & 15] +
              n[(t >> 16) & 15] +
              n[(t >> 28) & 15] +
              n[(t >> 24) & 15] +
              n[(r >> 4) & 15] +
              n[15 & r] +
              n[(r >> 12) & 15] +
              n[(r >> 8) & 15] +
              n[(r >> 20) & 15] +
              n[(r >> 16) & 15] +
              n[(r >> 28) & 15] +
              n[(r >> 24) & 15] +
              n[(o >> 4) & 15] +
              n[15 & o] +
              n[(o >> 12) & 15] +
              n[(o >> 8) & 15] +
              n[(o >> 20) & 15] +
              n[(o >> 16) & 15] +
              n[(o >> 28) & 15] +
              n[(o >> 24) & 15]
            );
          }),
          (t.prototype.toString = t.prototype.hex),
          (t.prototype.digest = function () {
            this.finalize();
            var e = this.h0,
              t = this.h1,
              r = this.h2,
              o = this.h3;
            return [
              255 & e,
              (e >> 8) & 255,
              (e >> 16) & 255,
              (e >> 24) & 255,
              255 & t,
              (t >> 8) & 255,
              (t >> 16) & 255,
              (t >> 24) & 255,
              255 & r,
              (r >> 8) & 255,
              (r >> 16) & 255,
              (r >> 24) & 255,
              255 & o,
              (o >> 8) & 255,
              (o >> 16) & 255,
              (o >> 24) & 255,
            ];
          }),
          (t.prototype.array = t.prototype.digest),
          (t.prototype.arrayBuffer = function () {
            this.finalize();
            var e = new ArrayBuffer(16),
              t = new Uint32Array(e);
            return (
              (t[0] = this.h0),
              (t[1] = this.h1),
              (t[2] = this.h2),
              (t[3] = this.h3),
              e
            );
          }),
          (t.prototype.buffer = t.prototype.arrayBuffer),
          (t.prototype.base64 = function () {
            for (var e, t, r, o = "", n = this.array(), i = 0; i < 15; )
              (e = n[i++]),
                (t = n[i++]),
                (r = n[i++]),
                (o +=
                  p[e >>> 2] +
                  p[63 & ((e << 4) | (t >>> 4))] +
                  p[63 & ((t << 2) | (r >>> 6))] +
                  p[63 & r]);
            return (e = n[i]), o + (p[e >>> 2] + p[(e << 4) & 63] + "==");
          }),
          v());
      f ? (module.exports = _) : (i.md5 = _);
    })();
  });



export function Str2Bytes(e) {
  var t = 0
    , r = e.length;
  if (r % 2 != 0)
    return null;
  r /= 2;
  for (var o = new Array, n = 0; n < r; n++) {
    var i = e.substr(t, 2)
      , i = parseInt(i, 16);
    o.push(i),
      t += 2
  }
  return o
} 
export const base64js = base64js_min
export const md5 = md5_min
